export default {
  noSamePass: 'Das Passwort stimmt nicht mit dem Bestätigungspasswort überein',
  loginSuccess: 'Anmeldung erfolgreich',
  registerSuccess: 'Registrierung erfolgreich',
  isHaveAccount: 'Haben Sie bereits ein Konto?',
  login: 'Anmelden',
  logout: 'Abmelden',
  forgetPass: 'Passwort vergessen?',
  register: 'Registrieren',
  registered: 'Bereits registriert,',
  emailTips: 'E-Mail',
  password: 'Passwort',
  pwdErr: 'Falsches Passwort.',
  confirmPass: 'Passwort bestätigen',
  countryTips: 'Wählen Sie Ihr Land',
  inviteCodeTips: 'Geben Sie den Einladungscode ein (optional)',
  verifyEmpty: 'Die Eingabe darf nicht leer sein',
  verifyEmail: 'Bitte geben Sie das korrekte E-Mail-Format ein',
  verifyPass: 'Das Passwort muss 6 bis 20 Zeichen lang sein und Buchstaben und Zahlen enthalten',
  confirmText: 'Ich habe gelesen und stimme zu',
  verifyCode: 'Verifizierungscode',
  verifyUrl: 'Bitte geben Sie das korrekte URL-Format ein',
  loginPwd: 'Login-Passwort',
  editPwd: 'Passwort ändern',
  changePwd: 'Login-Passwort ändern',
  setPwd: 'Passwort festlegen',
  and: 'und',
  privacyStatement: '《Datenschutzerklärung》',
  confirm: 'Bestätigen',
  cancel: 'Abbrechen',
  editSuccess: 'Erfolgreich geändert',
  email: 'E-Mail',
  emailCode: 'Verifizierungscode',
  newPwd: 'Neues Passwort',
  button: {
    search: 'Suchen',
    query: 'JETZT PRÜFEN',
    reset: 'Zurücksetzen',
    submit: 'Absenden',
    submitOrder: 'Bestellung absenden',
    save: 'Speichern',
  },
  holder: {
    select: 'bitte auswählen',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    max: 'höchste',
    min: 'Minimum',
    inputContent: 'Bitte Inhalt eingeben',
    inputEmailAccount: 'Bitte geben Sie die korrekte E-Mail-Adresse ein',
  },
  back: 'Willkommen zurück!',
  continueGoogle: 'Mit Google fortfahren',
  notAccount: 'Sie haben kein Konto?',
  signNow: 'Jetzt registrieren',
  termService: 'Nutzungsbedingungen',
  privacyPolicy: 'Datenschutzrichtlinie',
  helpCenter: 'Hilfe-Center',
  readPrivacy: 'Ich habe gelesen und akzeptiere',
  verifyAccept: 'Habe die Vereinbarung nicht gelesen',
  accountSecurity: 'Kontosicherheit',
  loginNow: 'Jetzt anmelden',
  resetPsd: 'Passwort zurücksetzen',
  verifiedEmail: 'E-Mail verifizieren',
  unverified: 'nicht verifiziert',
  emailVerification: 'E-Mail-Verifizierung',
  verifyMsg:
    'Ihre E-Mail wurde noch nicht verifiziert, daher können wir den Einkaufsvorgang vorübergehend nicht abschließen. Bitte verifizieren Sie Ihre E-Mail im persönlichen Bereich.',
  sendVerificationEmail: 'Verifizierungs-E-Mail senden',
  linkHasExpired: 'Der Link ist abgelaufen!',
  hasSendEmail: 'Verifizierungs-E-Mail wurde gesendet',
  shippingFeeEstimation: 'Versandkostenschätzung',
  homeText: 'Startseite',
  loginBgMsg: 'Treten Sie dem acbuy Discord bei, um weitere Vorteile zu erhalten',
  registerTitleMsg: 'STARTE DEINE REISE',
  registerBgMsg: 'Neukunden erhalten bei der Registrierung {coupon} + Versandgutscheine',
  announcement: 'Ankündigung',
  formAnnouncementMsg:
    'Ein neues Modell für das Partnerprogramm, ein duales Paketprovisionsmodell, nutzen Sie es, um Geld zu verdienen und zu sparen',
  incorrectAmount: 'Der Auszahlungsbetrag muss größer als 0 sein',
  readPrivacy1: 'Ich habe gelesen',
  andAgree: 'und stimme zu',
  aboveContent: 'den oben genannten Inhalten',
  purchasingNotice: 'Kaufhinweis',
  afterSaleService: 'Kundendienst',
  uniOrderAgreeText:
    'Der Link, den Sie auf dieser Seite eingereicht haben, gehört zu Produktlinks von Drittanbietern (wie Xianyu, Xiaohongshu, Bilibili usw.), und acbuy kann Ihnen nur helfen, den Händler des Links für Produktberatung, Kauf und die Organisation von Logistikdienstleistungen durch Dritte zu finden. acbuy kann die Produktqualität und -authentizität nicht unterscheiden, und Sie müssen die damit verbundenen Risiken vor der Bestellung tragen.',
  excludeFees: 'Wichtiger Hinweis: Internationale Versandkosten werden separat berechnet.',
  selectProductBtn: 'Produkte aus meinem Lager auswählen',
}
